import { render, staticRenderFns } from "./ProductRowMobile.vue?vue&type=template&id=2c0db142"
import script from "./ProductRowMobile.vue?vue&type=script&lang=js"
export * from "./ProductRowMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports